import { useEffect, useState } from "react";
import type { ReactElement } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "./redux/reducers";
import {
  checkAuthStatus,
  refreshToken,
  startTokenRefreshService,
  stopTokenRefreshService,
} from "./service/authService";
import { clearShopLogin } from "./redux/actions/shopLogin";
import { NavbarAndDashboardSkeleton } from "./components-atoms/NavbarAndDashboardSkeleton";

// Sets up token renewal and immediately refreshes the last access token for logged-in users
// Delays rendering the rest of the app until initialised
export function SetupTokenRefresh({
  children,
}: {
  children: ReactElement;
}): ReactElement {
  const [initialising, setInitialising] = useState(true);
  const dispatch = useDispatch();
  const userLoggedIn = useSelector<RootState>(
    ({ login: { userLoggedIn } }) => userLoggedIn,
  );

  useEffect(() => {
    if (userLoggedIn) {
      checkAuthStatus()
        .then((status) => {
          if (status && !status.Authenticated && !status.RefreshTokenValid) {
            dispatch(clearShopLogin());
            return;
          }

          return refreshToken(dispatch).then(() => {
            // setup token renewal only if refresh succeeded
            startTokenRefreshService(dispatch);
          });
        })
        .finally(() => {
          setInitialising(false);
        });
    } else {
      stopTokenRefreshService();
      setInitialising(false);
    }
  }, [userLoggedIn, dispatch]);
  return initialising ? <NavbarAndDashboardSkeleton /> : children;
}
